import { useState as s, useEffect as o } from "react";
const l = 769, i = 1184, D = 1184, a = 1600;
var c = /* @__PURE__ */ ((e) => (e.Mobile = "mobile", e.Tablet = "tablet", e.SmallDesktop = "smallDesktop", e.LargeDesktop = "largeDesktop", e))(c || {});
const n = (e) => e > a ? "largeDesktop" : e > i ? "smallDesktop" : e > l ? "tablet" : "mobile", m = () => {
  const [e, r] = s(
    n(window.innerWidth)
  );
  return o(() => {
    const t = () => {
      r(n(window.innerWidth));
    };
    return window.addEventListener("resize", t), () => {
      window.removeEventListener("resize", t);
    };
  }, []), e;
};
export {
  l as MOBILE_WIDTH,
  i as TABLET,
  D as TABLET_WIDTH,
  c as WidthType,
  m as useScreenSize
};
